<template>
  <el-table :data="menu_list" style="width: 100%" :loading="loading">
    <el-table-column prop="id" label="序号" width="100"> </el-table-column>
    <el-table-column prop="name" label="模块名称" width="180">
    </el-table-column>
    <el-table-column prop="type" label="模块类型"> </el-table-column>
    <el-table-column prop="is_show" label="绑定">
      <template slot-scope="scope">
        <el-switch
          @change="changeState($event, scope.row)"
          v-model="scope.row.is_show"
          active-text="开启"
          inactive-text="关闭"
        >
        </el-switch>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import CustomerService from "~/services/customer";
export default {
  props: {
    product_id: {
      required: true,
    },
    customer_id: {
      required: true,
    },
  },
  created() {
    this.getMenu();
  },
  data() {
    return {
      menu_list: [],
      loading: false,
    };
  },
  methods: {
    getMenu() {
      this.loading = true;
      CustomerService.getMenu({
        customer_id: this.customer_id,
        product_code: this.product_id,
      }).then((res) => {
        if (res.code) {
          this.$message({ type: "error", message: res.msg });
          return false;
        }
        this.menu_list = res.data;
      });
      this.loading = false;
    },

    changeState(state, row) {
      let title = state ? "开启" : "关闭";
      this.$confirm(
        "此操作将:(" + row.name + ")" + "模块" + title + ", 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          var params = {
            customer_id: this.customer_id,
            product_code: this.product_id,
            menu_id: row.id,
          };
          if (state) {
            var request = CustomerService.createMenu(params);
          } else {
            var request = CustomerService.deleteMenu(params);
          }
          request.then((res) => {
            if (res.code == 0) {
              this.$message({type: "success", message: title + "成功"});
              row["is_show"] = state;
            }else{
              row["is_show"] = !state;
            }
            this.loading = false;
          });
        })
        .catch((err) => {
          console.error(err);
          row["is_show"] = !state;
        });
    },

    /**
     * 修改产品类型
     * @param data
     */
    // changeType(data) {
    //   this.emit();
    // },
    // emit() {
    //   this.$emit("changeHead", this.form);
    // },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/customer/menu/MenuBind.vue